import { getAppUrl } from '@crm/utils'
import { NavigateFunction, useNavigate } from 'react-router-dom'

export const useAppNavigate = (): NavigateFunction => {
  const navigate = useNavigate()

  return (url = '', options?: { state?: Record<string, unknown> }) => {
    const to = getAppUrl(url as string)

    if (!to) return

    navigate(to, options)
  }
}
